import { render, staticRenderFns } from "./UVReport.vue?vue&type=template&id=ba484fae&scoped=true"
import script from "./UVReport.vue?vue&type=script&lang=js"
export * from "./UVReport.vue?vue&type=script&lang=js"
import style0 from "./UVReport.vue?vue&type=style&index=0&id=ba484fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba484fae",
  null
  
)

export default component.exports